import { useEffect } from "react";

/** How long the page must sit still before it counts as idle. */
const IDLE_AFTER_MS = 280;

/**
 * Puts `is-idle` on <html> whenever the reader isn't scrolling or swiping.
 *
 * The heartbeat and the other idle loops run off it (`--idle-play`, see
 * index.css): they play while the page is at rest and pause in place while it
 * moves, so a still page never reads as a frozen one. Scroll scenes keep their
 * own per-stage flag (SceneTrack); this one covers everything else — the plain
 * phone layout, the film button.
 */
export function usePageIdle() {
    useEffect(() => {
        const html = document.documentElement;
        let timer = 0;
        let moving = false;
        html.classList.add("is-idle");

        const onMove = () => {
            if (!moving) {
                moving = true;
                html.classList.remove("is-idle");
            }
            window.clearTimeout(timer);
            timer = window.setTimeout(() => {
                moving = false;
                html.classList.add("is-idle");
            }, IDLE_AFTER_MS);
        };

        window.addEventListener("scroll", onMove, { passive: true });
        window.addEventListener("touchmove", onMove, { passive: true });
        return () => {
            window.clearTimeout(timer);
            window.removeEventListener("scroll", onMove);
            window.removeEventListener("touchmove", onMove);
            html.classList.remove("is-idle");
        };
    }, []);
}
